import React, { memo } from 'react'
import withModuleContext from 'root/src/client/util/withModuleContext'
import assigneeListItemConnector from 'root/src/client/logic/assignee/connectors/assigneeListItemConnector'
import withStyles from '@material-ui/core/styles/withStyles'
import compose from 'ramda/src/compose'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { colorsNew, ltSmMediaQuery } from 'root/src/client/web/commonStyles'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import classnames from 'classnames'
import goToViewCreatorDataHandler from 'root/src/client/logic/creatorData/handlers/goToViewCreatorDataHandler'
import assigneeRouteSelector from 'root/src/client/logic/project/util/assigneeRouteSelector'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'

const styles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		width: 300,
		minHeight: 352,
		maxHeight: 370,
		borderRadius: 10,
		backgroundColor: colorsNew.dark1,
		cursor: 'pointer',
		boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.5)',
		userSelect: 'none',
		[ltSmMediaQuery]: {
			width: 220,
		},
	},
	centered: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		textAlign: 'center',
	},
	image: {
		borderRadius: [[10, 10, 0, 0]],
		height: 208,
		width: '100%',
		objectFit: 'cover',
	},
	displayName: {
		margin: [[10, 0, 5, 0]],
	},
	highlighted: {
		backgroundColor: colorsNew.light4,
		height: 13,
	},
	label: {
		marginBottom: 6,
	},
}

const CreatorCard = memo(({
	classes, displayName, followerCount, image, mnemonicId, platform, completedProjects,
}) => (
	<div
		className={classes.root}
		onClick={() => goToViewCreatorDataHandler(
			assigneeRouteSelector({ mnemonicId, displayName, platform }),
		)}
	>
		<LazyLoadImage
			src={addHttpsProtocol(image)}
			className={classes.image}
			alt={displayName}
		/>
		<div
			className={classnames(
				classes.displayName,
				classes.centered,
			)}
		>
			<Typography variant={typographyVariants.paragraphBold}>{displayName}</Typography>
		</div>
		<div
			className={classnames(
				classes.centered,
				classes.label,
			)}
		>
			<Typography
				color={colorsNew.light5}
				variant={typographyVariants.micro}
			>
				FOLLOWERS:
			</Typography>
			<Typography variant={typographyVariants.small}>{followerCount ? followerCount.toLocaleString('en-US') : ''}</Typography>
		</div>
		<div
			className={classnames(
				classes.highlighted,
				classes.centered,
			)}
		>
			<Typography
				color={colorsNew.dark2}
				variant={typographyVariants.micro}
			>
				DARES COMPLETE:
			</Typography>
		</div>
		<div
			className={classnames(
				classes.centered,
			)}
		>
			<Typography
				variant={typographyVariants.heading2}
			>
				{completedProjects?.toLocaleString('en-US')}
			</Typography>
		</div>
	</div>
))

export default compose(
	withModuleContext,
	assigneeListItemConnector,
	withStyles(styles),
)(CreatorCard)
